export const shortenUrl = async (url) => {
  // create a get api call to shorten the url
  const urlEncoded = encodeURIComponent(url);
  const shortenedUrl = fetch(
    "https://tinyurl.com/api-create.php?url=" + urlEncoded
  ).then((response) => response.text());

  return shortenedUrl;
};
